<template>
    <div class="card card-default">
        <div class="card-header">
            Update Team Dashboard Settings
        </div>
        <div class="card-body" >
            <!-- Success Message -->
            <div class="alert alert-success" v-if="form.successful">
                Your team dashboard settings have been updated!
            </div>

            <form role="form">
                <!-- Domain -->
                <div class="form-group row" :class="{'has-error': form.errors.has('guid')}"  >
                    <label class="col-md-4 col-form-label text-md-right ">Enable Link</label>
                    <div class="col-md-6 ">
                        <input type="checkbox" name="enabled" v-model="form.div_enabled" id="enable_dashboard_url" v-on:click="toggleEnabled()"/>
                    </div>

                    <label class="col-md-4 col-form-label text-md-right">Dashboard Guid</label>

                    <div class="col-md-6">
                        <input type="text" v-bind:disabled="!form.div_enabled" class="form-control" name="guid" v-model="form.guid" :class="{'is-invalid': form.errors.has('guid')}">
                        <span class="help-block" v-show="form.errors.has('guid')">
                            {{ form.errors.get('domain') }}
                        </span>
                    </div>
                    <label class="col-md-4 col-form-label text-md-right">URL Template</label>
                    <div class="col-md-6" >
                        <input type="text" v-bind:disabled="!form.div_enabled" class="form-control" name="domain" v-model="form.url_template" :class="{'is-invalid': form.errors.has('url_template')}">
                        <span class="help-block" v-show="form.errors.has('url_template')">
                            {{ form.errors.get('url_template') }}
                        </span>
                    </div>
                </div>

                <!-- Update Button -->
                <div class="form-group row mb-0">
                    <div class="offset-md-4 col-md-6">
                        <button type="submit" class="btn btn-primary"
                                @click.prevent="update"
                                :disabled="form.busy">
                            Update
                        </button>
                    </div>
                </div>

                <small class="help-block" v-show="form.div_enabled" >
                   <b>Preview</b><br/>
                    <a target="_voxie_analytics" :href="getDashboardUrl(this.form.guid, this.form.url_template, this.team.id)" >
                        {{ this.getDashboardUrl(this.form.guid, this.form.url_template, this.team.id) }}</a>
                </small>
            </form>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    props: ['team'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: new SparkForm({
                guid: '',
                url_template: '',
                div_enabled: false,
            }),
        };
    },

    /**
     * Prepare the component.
     */
    mounted() {
        this.$nextTick(function () {
            this.form.dashboard_url = this.team.dashboard_url;
            this.parseGuidAndTemplate();

            if (!this.form.dashboard_url || this.form.dashboard_url.length < 1) this.form.div_enabled = false;
            else this.form.div_enabled = true;
        });

        Bus.$on(`sparkFormUpdated.${this.form.sparkFormId}`, this.$forceUpdate)
    },

    methods: {
        /**
         * Update the team name.
         */
        update() {
            if (this.form.div_enabled) {
                this.setDashboardUrl();
            } else {
                this.form.dashboard_url = '';
            }

            if (this.team.dashboard_url !== this.form.dashboard_url) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'Changing the dashboard URL may cause analytics to no longer function.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'I am aware, change the settings!',
                }).then(({ value }) => {
                    if (!value) {
                        return;
                    }

                    Spark.put(`/settings/teams/${this.team.id}/name`, this.form).then(
                        () => {
                            Bus.$emit('updateTeam');
                            Bus.$emit('updateTeams');
                        },
                        () => {
                            this.form.domain = this.team.domain;
                        }
                    );
                });
            }
        },

        toggleEnabled() {
            if (this.form.enabled) {
                this.form.guid = '';
                this.form.url_template = '';
                this.form.enabled = false;
            }
        },

        parseGuidAndTemplate() {
            if (typeof this.form.dashboard_url !== 'string' || this.form.dashboard_url.length === 0) {
                this.form.url_template = '';
                this.form.guid = '';
            } else {
                let parts1 = this.form.dashboard_url.split('?');
                this.form.url_template = parts1[1] || '';

                let parts2 = parts1[0].split('/');
                this.form.guid = parts2[parts2.length - 1];
            }

            return;
        },

        setDashboardUrl() {
            if (this.form.guid === '') this.form.dashboard_url = '';
            else this.form.dashboard_url = this.getDashboardUrl(this.form.guid, this.form.url_template);
        },

        getDashboardUrl(guid, template, team_id) {
            let urlbase = 'https://metabase.voxie.com/public/dashboard/';

            let url = urlbase + guid;
            if (template) {
                url += '?' + template;
            }

            if (typeof team_id !== 'undefined') return url.replace(/{team->id}/, team_id);
            else return url;
        },
    },
};
</script>
